export const cookieConsentContent = {
  title: 'Pliki cookie i prywatność',
  description:
    'Używamy plików cookie do statystyk (Google Analytics) oraz - po Twojej zgodzie - do reklam. Możesz zaakceptować wszystkie, odrzucić opcjonalne lub wybrać kategorie.',
  acceptAll: 'Akceptuję wszystkie',
  rejectOptional: 'Tylko niezbędne',
  customize: 'Dostosuj',
  saveChoices: 'Zapisz wybór',
  closeSettings: 'Wróć',
  necessaryTitle: 'Niezbędne',
  necessaryDescription: 'Wymagane do działania aplikacji. Zawsze włączone.',
  analyticsTitle: 'Statystyka',
  analyticsDescription: 'Pomaga nam zrozumieć, jak korzystasz z aplikacji (Google Analytics).',
  marketingTitle: 'Marketing',
  marketingDescription: 'Reklamy i personalizacja (Google Ads).',
  privacyLabel: 'Polityka prywatności',
  manageCookiesLabel: 'Ustawienia cookies',
};
